import React from 'react';
import { PaginationWrapper, PageButton, CurrentPageButton } from "./PaginationStyle";

const Pagination = ({ currentPage, itemsPerPage, totalItems, onPageChange, disabled = false }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const pageButtons = [];
  const pageLimit = 10;

  const startPage = currentPage <= pageLimit ? 1 : currentPage - Math.floor(pageLimit / 2);
  const endPage = startPage + pageLimit - 1 < totalPages ? startPage + pageLimit - 1 : totalPages;

  const handleClick = (page) => {
    if (!disabled) {
      onPageChange(page);
    }
  };

  // Botón "Primera página" solo si no está en el rango visible
  if (currentPage !== 1 && startPage > 1) {
    pageButtons.push(
      <PageButton key="start" onClick={() => handleClick(1)} disabled={disabled}>
        1
      </PageButton>
    );
  }

  // Botón "Anterior" solo si no está en la primera página
  if (currentPage > 1) {
    pageButtons.push(
      <PageButton key="prev" onClick={() => handleClick(currentPage - 1)} disabled={disabled}>
        &laquo;
      </PageButton>
    );
  }

  // Páginas visibles
  for(let i = startPage; i <= endPage; i++) {
    const Button = i === currentPage ? CurrentPageButton : PageButton;
    pageButtons.push(
      <Button key={i} onClick={() => handleClick(i)} disabled={disabled}>
        {i}
      </Button>
    );
  }

  // Botón "Siguiente" solo si no está en la última página
  if (currentPage < totalPages) {
    pageButtons.push(
      <PageButton key="next" onClick={() => handleClick(currentPage + 1)} disabled={disabled}>
        &raquo;
      </PageButton>
    );
  }

  // Botón "Última página" solo si no está en el rango visible
  if (currentPage !== totalPages && endPage < totalPages) {
    pageButtons.push(
      <PageButton key="end" onClick={() => handleClick(totalPages)} disabled={disabled}>
        {totalPages}
      </PageButton>
    );
  }

  return (
    <PaginationWrapper>
      {pageButtons}
    </PaginationWrapper>
  );
};

export default Pagination;
